import * as React from 'react';
import { useIntl } from 'react-intl';

import { DrawerContext } from '@notino/react-styleguide';

import { dispatchTrackingEvent } from '@context/tracking/utils';

import messages from '../../../../../../../messages';
import { orderByOptions } from '../../../constants';
import { SORTING_DRAWER_TITLE_ID } from '../../constants';
import {
  useReviewSortingActions,
  useReviewSortingStore,
} from '../../Stores/sortingStore';

import { ListWrapper, StyledRadioButton } from './styled';

const SORTING_RADIO_GROUP_NAME = 'reviewsSortBy';

export const DrawerContent: React.FC = () => {
  const { formatMessage } = useIntl();

  const { closeDrawer } = DrawerContext.useDrawerContext();

  const { orderBy: currentOrderBy, orderDesc: currentOrderDesc } =
    useReviewSortingStore();
  const { changeOrder } = useReviewSortingActions();

  const options = React.useMemo(
    () =>
      orderByOptions.map((orderBy) => ({
        key: orderBy.key,
        desc: orderBy.desc,
        label: formatMessage(
          messages[
            `orderReviewsBy${orderBy.key}${orderBy.desc ? 'Desc' : 'Asc'}`
          ]
        ),
      })),
    [formatMessage]
  );

  const onChange = (option) => {
    changeOrder({ key: option.key, desc: option.desc });
    closeDrawer();

    dispatchTrackingEvent({
      event: 'sorting_set',
      sorting: {
        type: 'reviews',
        name: option.key,
      },
      _clear: true,
    });
  };

  return (
    <ListWrapper role="radiogroup" aria-labelledby={SORTING_DRAWER_TITLE_ID}>
      {options.map((option) => (
        <StyledRadioButton
          key={`${option.key}-${option.desc ? 'desc' : 'asc'}`}
          name={SORTING_RADIO_GROUP_NAME}
          aria-label={option.label}
          checked={
            option.key === currentOrderBy && option.desc === currentOrderDesc
          }
          disabled={false}
          onChange={() => {
            onChange(option);
          }}
        >
          {option.label}
        </StyledRadioButton>
      ))}
    </ListWrapper>
  );
};
